<script setup lang="ts">
useSeoMeta({
  title: 'Doe mee',
  description: 'Doe mee met Ongehoord en help het welzijn van dieren te verbeteren. Ontdek hoe je kunt bijdragen aan ons werk.',
})
</script>

<template>
  <ApplicationPageContent />
</template>
